import { ProgressBar } from 'components/molecules/progress-bar';
import { EffortDurationField } from 'components/organisms/task-pane/task-detail/task-fields/default-task-fields/effort-as-duration';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacEffortDurationField = withAccess(EffortDurationField);
export const RbacProgressBar = withAccess(ProgressBar);
